import * as React from "react"
import {useEffect} from "react";
import {DrawerSeeker} from "@ui-seeker/core";
import { isEmpty } from '@ui-seeker/utils'

import { adminProductReviewEditClicked, fillCommonFormValue } from "../@signals";
import { useAdminProductReviewForm } from "../@hooks";
import AdminProductReviewFormDrawerContent from "./Content";


export default function AdminProductReviewFormDrawer() {
	const { formData, formTitle, showForm, handleUpdate } = useAdminProductReviewForm()

	useEffect(() => {
		if (!isEmpty(formData))
			fillCommonFormValue({
				countryForm: formData.country || null,
				siteForm: formData.siteID || null,
				brandForm: formData.brandID || null,
				skuForm: formData.skuID || null
			})
	}, [JSON.stringify(formData)]);

	if (!showForm) return <></>

	return <DrawerSeeker
		isOpen={!isEmpty(formData)}
		controller={() => adminProductReviewEditClicked.value = null}
		title={`EDIT ${formTitle}`}
		width="40%"
		successProps={{ onClick: handleUpdate }}
	>
		<AdminProductReviewFormDrawerContent formData={formData} />
	</DrawerSeeker>
}